import { Component, OnInit } from '@angular/core';
import { Estado } from '../../_models/estado';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { EstadoRolService } from '../../_services/estado-rol.service';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolesService } from '../../_services/roles.service';
import { forkJoin } from 'rxjs';
import { Rol } from '../../_models/rol';
import { EstadoRol } from '../../_models/estado-rol';
import { EstadoService } from '../../_services/estado.service';

@Component( {
  selector: 'app-estados-rol',
  templateUrl: 'estados-rol.component.html'
} )

export class EstadosRolComponent implements OnInit {

  estado: Estado;
  carInformacionInicial = true;
  columnas: any[] = [];
  lisTodosRoles: Rol[] = [];
  lisEstadoRol: EstadoRol[] = [];
  lisRoles: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;

  constructor( private estRolServicio: EstadoRolService,
               private route: ActivatedRoute, private location: Location,
               private estServicio: EstadoService,
               private navServicio: NavService, private conServicio: ConfirmationService,
               private fb: FormBuilder, private rolServicio: RolesService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreRol', header: this.navServicio.buscarMensaje( 'ESTADOSROL.LBL_ROL' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin( this.estRolServicio.listadoPorEstado( params[ 'id' ] ),
        this.rolServicio.listRoles(),
        this.estServicio.obtenerPorId( params[ 'id' ] ) ).subscribe( ( [ lisEstadosRol, lisRoles, estado ] ) => {
        this.estado = estado;
        this.lisTodosRoles = lisRoles;
        this.lisEstadoRol = lisEstadosRol.filter( x => x.indicadorHabilitado );
        this.cargarFormulario();
        this.cargarListadoRoles();
        this.carInformacionInicial = false;
      } );
    } );


  }

  cargarListadoRoles() {
    this.lisRoles = [];
    this.lisTodosRoles.map( ( s: Rol ) => {
      if ( s.indicadorHabilitado && !this.lisEstadoRol.find( x => x.idRol === s.idRol ) ) {
        this.lisRoles.push( { label: s.nombre, value: s.idRol } );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idEstadoRol: [ null ],
      idEstado: [ this.estado.idEstado, [ Validators.required ] ],
      idRol: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true ],
      auditoriaFecha: [ null ],
      auditoriaUsuario: [ null ]
    } );
  }

  regresar() {
    this.location.back();
  }

  get f() {
    return this.formulario.controls;
  }

  inhabilitar( estRol: EstadoRol ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.carInformacionInicial = true;
        estRol.indicadorHabilitado = false;
        this.estRolServicio.actualizar( estRol ).subscribe( regActualizado => {
          const a = this.lisEstadoRol.findIndex( x => x.idEstadoRol === estRol.idEstadoRol );
          if ( a >= 0 ) {
            this.lisEstadoRol.splice( a, 1 );
          }
          this.cargarListadoRoles();
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const estRol = this.formulario.value;
      this.estRolServicio.crear( estRol ).subscribe( regCreado => {
        estRol.idEstadoRol = regCreado.idEstadoRol;
        const a = this.lisTodosRoles.find( x => x.idRol === estRol.idRol );
        if ( a ) {
          estRol.nombreRol = a.nombre;
        }
        this.lisEstadoRol = [ ...this.lisEstadoRol, estRol ];
        this.formulario.reset();
        this.f.idEstado.setValue( this.estado.idEstado );
        this.f.indicadorHabilitado.setValue( true );
        this.cargarListadoRoles();
        this.submitted = false;
        this.guardando = false;
        this.navServicio.setMesage( 1 );
      }, error => {
        this.guardando = false;
        this.navServicio.setMesage( 3 );
      } );
    }
  }
}
